<script>
	// NPM Modules
	import { navigate } from 'svelte-navaid';
	// Components
	import SelectInput from '@/Components/SelectInput.svelte';
	// Stores
	import MeetingStore from '@/Stores/Racing/MeetingStore.js';
	import RaceStore from '@/Stores/Racing/RaceStore.js';
	// Constants
	import { Sport } from '@/Constants/Sport.js';

	export let selectedMeetingId;
	export let race;

	$: selectedMeetingId && changeRace();

	function changeRace() {
		let nextRace = RaceStore.getNextRaceId(selectedMeetingId);
		if (race && selectedMeetingId.toString() === race.meeting_id) {
			navigate(`/racing/meetings/${selectedMeetingId}/races/${race.id}`);
		} else if (nextRace) {
			navigate(`/racing/meetings/${selectedMeetingId}/races/${nextRace}`);
		} else {
			navigate(`/racing/meetings/${selectedMeetingId}`);
		}
	}
</script>

<SelectInput className="_pr-6 _pb-8 _w-full" name="meeting" bind:value={selectedMeetingId}>
	<option>------ GALLOPS -------</option>
	{#each $MeetingStore.where('race_type.id', Sport.Gallop).sortBy('name').all() as meeting (meeting.id)}
		<option value={meeting.id}>{meeting.name}</option>
	{/each}
	<option>------- HARNESS ------</option>
	{#each $MeetingStore.where('race_type.id', Sport.Harness).sortBy('name').all() as meeting (meeting.id)}
		<option value={meeting.id}>{meeting.name}</option>
	{/each}
	<option>----- GREYHOUNDS -----</option>
	{#each $MeetingStore.where('race_type.id', Sport.Greyhound).sortBy('name').all() as meeting (meeting.id)}
		<option value={meeting.id}>{meeting.name}</option>
	{/each}
</SelectInput>
